<template>
  <div class="endpoint_head">
    <h2>Get ticket</h2>

    <div class="route">
      <i
        @click="
          $router.push('/documentation/api/tickets#get');
          $toast.info('Set URL to endpoint');
        "
        :style="{ color: 'var(--clr-secondary)', cursor: 'pointer' }"
        class="fas fa-hashtag"
      ></i>
      <p class="tag tag-blue">GET</p>
      <p class="url">{{ apiUrl }}<span>/tickets/:id</span></p>
    </div>

    <div class="description">
      <p>Get a ticket by ID</p>
    </div>
  </div>

  <div class="endpoint_body">
    <div class="request">
      <h3>Request</h3>

      <!-- Path params -->
      <div class="endpoint_body_section path">
        <div class="head">
          <h4>Path Parameters</h4>
        </div>

        <ul>
          <li>
            <div class="col value">
              <p class="bold">ID</p>
              <p class="examples">
                Examples: <span>5f8a1d9b-3b0b-4c9a-9c0d-1a2b3c4d5e6f</span>
              </p>
            </div>

            <div class="col">
              <p class="required">required</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="response">
      <h3>Response</h3>

      <!-- Body -->
      <div class="endpoint_body_section path">
        <div class="head">
          <h4>Body</h4>
        </div>

        <ul>
          <li>
            <div class="col value">
              <p class="bold">ticket</p>
              <p class="examples">
                Examples:
                <span
                  >{ "salonId": "622ec883ec2552e0d48ed289", "number": 772,
                  "status": "in-progress", "kioskClient": { "notifications": {
                  "email": true, "text": true, "marketing": true } }, "items": [
                  { "status": "default", "quantity": 1, "staff": { "staffId":
                  "622ec119ec2552e0d48ed123", "firstName": "John", "lastName":
                  "Doe", "email": "john@doe.com", "phoneNumber": "5551112222",
                  "commission": 60, "exemptFromServiceFees": false, "_id":
                  "649dc0a76831aace66a659b3", "customCommissions": [] }, "item":
                  { "title": "Service", "color": "#a6c7ea", "isCommissioned":
                  "false", "taxRate": 0, "price": 100, "duration": 20,
                  "categoryId": "622ec883ec2552e0d48ed213" }, "_id":
                  "649dc0a76831aace66a659b2" } ], "packages": [], "reviewed":
                  false, "onlineOrder": false, "_id":
                  "649dc0a76831aace66a659b1", "created_at":
                  "2023-06-29T17:34:31.378Z", "updated_at":
                  "2023-06-29T17:34:31.378Z", "tips": [], "payments": [], "__v":
                  0 }</span
                >
              </p>
            </div>

            <div class="col">
              <p class="required">required</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    apiUrl() {
      return process.env.VUE_APP_RASERVA_BACKEND;
    },
  },
};
</script>

<style lang="scss" scoped>
.endpoint {
  .tag {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 700;
    padding: 8px;
    border-radius: 5px;
    color: white;

    &-blue {
      background-color: var(--clr-secondary);
    }
  }

  &_head {
    h2 {
      font-size: 36px;
      margin-bottom: 16px;
    }

    .route {
      padding: 8px 16px;
      border-radius: 5px;
      background-color: var(--clr-white-2);
      display: flex;
      align-items: center;
      gap: 16px;

      .url {
        color: var(--clr-gray);

        span {
          color: var(--clr-primary);
          font-weight: 700;
        }
      }
    }

    .description {
      margin-top: 32px;
    }
  }

  &_body {
    .request,
    .response,
    .reqResExamples {
      margin-top: 32px;
      padding: 16px;
      border-radius: 5px;
      border: 1px solid var(--clr-light);
    }

    h3 {
      font-size: 24px;
      margin-bottom: 32px;
    }

    &_section {
      &:not(:first-child) {
        margin-top: 32px;
      }

      .head {
        display: flex;
        justify-content: space-between;

        h4 {
          font-size: 20px;
          margin-bottom: 16px;
          color: var(--clr-secondary);
        }

        p {
          font-size: 14px;
          color: var(--clr-gray);
        }
      }

      ul {
        .subitem {
          margin-left: 32px;
        }

        li {
          display: flex;
          justify-content: space-between;
          font-size: 14px;

          &:not(:first-child) {
            margin-top: 16px;
          }

          .value {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .bold {
            font-weight: 700;
          }
          .required {
            color: orangered;
          }

          .description {
            margin: 4px 0;
            color: var(--clr-gray);
          }

          .examples {
            span {
              background-color: var(--clr-white-2);
              padding: 4px 8px;
              border-radius: 5px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
